//import React from "react";
//import Navbar from "../components/Navbar";
//import "./FirmaBilgiFormu.css";
//import bgSvg from "../assets/bg.svg";


//export default function FirmaBilgiFormu() {
//    return (
//        <div className="firma-page">
//            <Navbar />

//            <div className="firma-card">
//                <h1 className="firma-title">FİRMA TANITIM BİLGİ FORMU</h1>

//                <div className="firma-info">

//                    <div className="info-row">
//                        <strong>Firma Adı:</strong>
//                        <span>SPORTIVE SPOR MALZEMELERİ TİC. A.Ş.</span>
//                    </div>

//                    <div className="info-row">
//                        <strong>Adres:</strong>
//                        <span>
//                            Suadiye Mah. Ayşecavuş Cad. Brandroom Blok No:3 İç Kapı No:3 Kadıköy / İstanbul
//                        </span>
//                    </div>

//                    <div className="info-row">
//                        <strong>Vergi Dairesi:</strong>
//                        <span>Marmara Kurumlar</span>
//                    </div>

//                    <div className="info-row">
//                        <strong>Vergi Numarası:</strong>
//                        <span>849 029 6921</span>
//                    </div>

//                    <div className="info-row">
//                        <strong>Adres Kodu:</strong>
//                        <span>106-575-6676</span>
//                    </div>

//                    <div className="info-row">
//                        <strong>Ticaret Sicil No:</strong>
//                        <span>300283</span>
//                    </div>

//                    <div className="info-row">
//                        <strong>Mersis No:</strong>
//                        <span>0849029692100022</span>
//                    </div>

//                    <div className="info-row">
//                        <strong>Web Sitesi:</strong>
//                        <span>www.sportive.com.tr</span>
//                    </div>

//                    <div className="info-row">
//                        <strong>Telefon:</strong>
//                        <span>0850 221 23 23</span>
//                    </div>

//                    <div className="info-row">
//                        <strong>Fax:</strong>
//                        <span>0850 955 85 08</span>
//                    </div>

//                    <div className="info-row">
//                        <strong>E-Fatura Kullanımı:</strong>
//                        <span>E-Fatura Sistemine Dahil</span>
//                    </div>

//                    <div className="info-row">
//                        <strong>Kep Adresi:</strong>
//                        <span>sportive@hs03.kep.tr</span>
//                    </div>

//                </div>

//                {/* Banka Bilgileri */}
//                <h2 className="bank-title">Banka Hesap Bilgileri</h2>

//                <div className="firma-info">
//                    <div className="info-row">
//                        <strong>Garanti Bankası:</strong>
//                        <span>TR49 0006 2000 3810 0006 2476 44</span>
//                    </div>

//                    <div className="info-row">
//                        <strong>İş Bankası:</strong>
//                        <span>TR12 0006 4000 0014 9002 9692 12</span>
//                    </div>

//                    <div className="info-row">
//                        <strong>Yapı Kredi Bankası:</strong>
//                        <span>TR71 0006 7010 0000 0051 7967 87</span>
//                    </div>

//                    <div className="info-row">
//                        <strong>Ziraat Bankası:</strong>
//                        <span>TR21 0001 0014 5557 3070 7650 01</span>
//                    </div>
//                </div>
//            </div>
//        </div>
//    );
//}


import React from "react";
import Navbar from "../components/Navbar";
import "./FirmaBilgiFormu.css";

export default function FirmaBilgiFormu() {
    const bilgiler = [
        ["Firma Adı", "SPORTIVE SPOR MALZEMELERİ TİC. A.Ş."],
        ["Adres", "Suadiye Mah. Ayşecavuş Cad. Brandroom Blok No:3 İç Kapı No:3 Kadıköy / İstanbul"],
        ["Vergi Dairesi", "Marmara Kurumlar"],
        ["Vergi Numarası", "849 029 6921"],
        ["Adres Kodu", "106-575-6676"],
        ["Ticaret Sicil No", "300283"],
        ["Mersis No", "0849029692100022"],
        ["Web Sitesi", "www.sportive.com.tr"],
        ["Telefon", "0850 221 23 23"],
        ["Fax", "0850 955 85 08"],
        ["E-Fatura Kullanımı", "E-Fatura Sistemine Dahil"],
        ["Kep Adresi", "sportive@hs03.kep.tr"]
    ];

    return (
        <div className="firma-page">
            <Navbar />

            <div className="firma-card">
                <h1 className="firma-title">FİRMA TANITIM BİLGİ FORMU</h1>

                {/* Bilgiler Grid ile otomatik hizalanıyor */}
                <div className="firma-grid">
                    {bilgiler.map(([label, value], index) => (
                        <React.Fragment key={index}>
                            <div className="label">{label}:</div>
                            <div className="value">{value}</div>
                        </React.Fragment>
                    ))}
                </div>

                {/* BANKA BİLGİLERİ */}
                <h2 className="bank-title">Banka Hesap Bilgileri</h2>

                <div className="firma-grid">
                    <div className="label">Garanti Bankası:</div>
                    <div className="value">TR49 0006 2000 3810 0006 2476 44</div>
                </div>
            </div>
        </div>
    );
}
